import { render } from "./ContentComponent.vue?vue&type=template&id=8a8af54e"
import script from "./ContentComponent.vue?vue&type=script&lang=js"
export * from "./ContentComponent.vue?vue&type=script&lang=js"

import exportComponent from "/builds/phi-indonesia/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__